export const noop = () => {
};

export const openLink = (url: string, target: string = '_blank') => {
  const link = document.createElement('a');
  link.href = url;
  link.target = target;
  link.click();
};
